module.exports = "https://static.wmbcdn.com/uniweb/images/903ddb0a304fbc2a0bc7a2f26bb6bfea.svg";